
<div *ngIf="data.iconHeader" class="iq-icon-container">
  <div class="iq-image-icon--{{data.iconHeader}}"></div>
</div>


<ng-container *ngIf="data.showLoading">
  <p>{{data.loadingMessage}}</p>
  <div class="wrapper">
    <span class="spinner"></span>
  </div>
</ng-container>
<ng-container *ngIf="!data.showLoading">
<iq-dialog-header header="{{data.title}}"></iq-dialog-header>
<p *ngIf="messageHtml" [innerHTML]="messageHtml"></p>
<div class="iq-dialog-buttons" [class.ok-only]="data.okOnly">
  <button class="button primary-1" type="button" (click)="onOk()">{{data.okLabel}}</button>
  <button *ngIf="!data.okOnly" class="button secondary-4" type="button" (click)="onCancel()">{{data.cancelLabel}}</button>
</div>
</ng-container>